import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer class="pt-6 pb-3">
        <div class="container">
          <div class="row justify-content-center text-center align-items-center">
            <div class="col-lg-7 co-md-10 col-12 px-0">
              <div class="mb-2">
                <Link to="/">
                  <img
                    src="./assets/images/logo.png"
                    width="180"
                    class="mb-2 logo-inverse"
                  />
                </Link>
                <p class="lead lh-sm fs-4 fw-normal">
                  Your trusted travel partner in India, curating tailor-made
                  holidays, family trips, and luxury getaways that turn every
                  journey into a lifelong memory.
                </p>
              </div>
              <div>
                <h3 class="fw-bold mb-0 text-dark">Connect with Our Team</h3>
                <p className="m-0 fs-5">Traveel Bug</p>
                <p class="lh-sm mb-1">
                  <a href="mailto: info@Microfinancebazar.in" className="fs-4">
                    info@traveelbug.com
                  </a>
                </p>
                <p class="lh-sm">
                  <a href="tel: +917987272900" class="text-dark fw-semibold">
                    (+91) 7987272900
                  </a>
                  ,{" "}
                  <a href="tel: +919009062040" class="text-dark fw-semibold">
                    (+91) 9009062040
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-4 mb-3" />
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-6 col-12">
              <span>
                © <span id="copyright4">2025</span> Traveel Bug
              </span>
            </div>

            <div class="col-lg-6 col-md-12 col-12 d-lg-flex justify-content-center">
              <nav class="nav nav-footer mb-lg-0 mb-1">
                <Link to="/disclaimer" class="nav-link ps-0" href="#">
                  Disclaimer
                </Link>
                <Link to="/privacy" class="nav-link px-3" href="#">
                  Privacy Policy
                </Link>
                <Link to="/faq" class="nav-link" href="#">
                  FAQs
                </Link>
              </nav>
            </div>
            <div class="col-lg-3 col-md-12 col-12 d-lg-flex justify-content-end">
              <div>
                <a href="https://www.facebook.com/profile.php?id=61583614931392" target="_blank" class="me-3">
                  <i class="bi bi-facebook text-dark"></i>
                </a>
                <a href="https://www.instagram.com/go_wiith_traveelbug?igsh=MjA1a2djc3ppdTJ1" target="_blank" class="me-3">
                  <i class="bi bi-instagram text-dark"></i>
                </a>
                <a href="#">
                  <i class="bi bi-youtube text-dark"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
